import anime from 'animejs'

let messagesContainer = document.querySelector('#formMessages')
let messages

export function init ()
{
	if (!messagesContainer)
	{
		messagesContainer = document.createElement('div')
		messagesContainer.id = 'formMessages'
		
		document.body.append(messagesContainer)
	}
	
	messages = messagesContainer
}

export function add (success, message, form)
{
	let formMessageContainer = form.querySelector('.message')
	
	if(formMessageContainer){
		formMessageContainer.dataset.type = success ? 'success' : 'error'
		formMessageContainer.innerHTML = ''
		
		if (Array.isArray(message))
		{
			message.forEach(el =>
			{
				formMessageContainer.innerHTML += `<p>${el}</p>`
			})
		}
		else
		{
			formMessageContainer.innerHTML += `<p>${message}</p>`
		}
		
		return
	}
	
	const div = document.createElement('div')
	div.classList.add('message', success ? 'success' : 'error')
	
	const inner = document.createElement('div')
	inner.classList.add('inner')
	inner.innerHTML = message
	
	div.append(inner)
	
	const timeline = anime.timeline({
		targets: div,
		easing: 'easeOutQuart',
		duration: 400
	})
	
	timeline.add({
		opacity: [0, 1],
		translateY: ['100%', 0],
		begin: () =>
		{
			messages.appendChild(div)
		}
	}).add({
		opacity: 0,
		translateY: '-100%',
		complete: () =>
		{
			div.remove()
		}
	}, '+=3000')
}
